module.exports = __webpack_public_path__ + "static/media/super-thank-you.13dabf4b.svg";